/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export {BrowserAnimationBuilder as ɵBrowserAnimationBuilder} from './animation_builder';
export {RuntimeErrorCode as ɵRuntimeErrorCode} from './errors';
export {AnimationGroupPlayer as ɵAnimationGroupPlayer} from './players/animation_group_player';

export const ɵPRE_STYLE = '!';
